import DataTableCellField from "@/components/data-table/components/DataTableCellField";
import { DirtyAwareCell } from "@/contexts/FormTableCellDirtyContext";
import { PayrollSplit } from "@/types/payrollSplit";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createAgreementStatusCurrent, createTaxStatusFinal } from "../columns";

export const usePayrollSplitColumnOverrides = (): Record<
  string,
  ColumnDef<PayrollSplit>
> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      amount_agreement1: {
        id: "amount_agreement1",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.amount_agreement1`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      amount_agreement2: {
        id: "amount_agreement2",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.amount_agreement2`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      amount_to_pay: {
        id: "amount_to_pay",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.amount_to_pay`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      permanent_comment: {
        id: "permanent_comment",
        meta: {
          allowColumnToBeALink: false,
        },
      },
      comment: {
        id: "comment",
        header: "payrolls.fields.comment_split",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.comment`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest1: {
        id: "contest1",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest1`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest2: {
        id: "contest2",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest2`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest3: {
        id: "contest3",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest3`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest4: {
        id: "contest4",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest4`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest5: {
        id: "contest5",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest5`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest6: {
        id: "contest6",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest6`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      contest7: {
        id: "contest7",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.contest7`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      tax_status_final: createTaxStatusFinal(t),
      agreement_status_current: createAgreementStatusCurrent(t),
    }),
    [t],
  );
};
